import { Component, inject } from '@angular/core';
import { ForecastService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ForecastCreateDto,
  ForecastDto,
  ForecastExcelDownloadDto,
  ForecastUpdateDto,
} from '../proxy/controlling/dtos/forecast';
import { FORECAST_CONFIG, FORECAST_FIELDS } from './forecast.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-forecast',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ForecastService, ConfirmationService],
  templateUrl: './forecast.html',
  styleUrl: './forecast.scss',
})
export class Forecast extends BaseCrudComponent<
  ForecastDto,
  ForecastCreateDto,
  ForecastUpdateDto,
  ForecastExcelDownloadDto
> {
  service = inject(ForecastService);
  config = FORECAST_CONFIG;
  fields = FORECAST_FIELDS;

  protected prepareUpdateDto(data: any, selected: ForecastDto): ForecastUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Forecast';
  }
}
